module.exports = __webpack_public_path__ + "static/media/volleyball-2.5fe75037.svg";